import axios from 'axios';

export default function searchByAttribute(tableName, rowCount, attributeName, attributeValue, config) {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
    'x-location-id': localStorage.getItem('locationId')
  };
  const url = config.postSearchService;
  let typeName = '';
  switch (tableName) {
    case 'contract-rates':
      typeName = 'SEARCH_CONTRACTRATE_FETCH';
      break;
    default:
      typeName = 'SEARCH_FETCH';
  }

  return dispatch => dispatch({

    type: typeName,
    payload: axios({ method: 'post', url, headers, data: { search: { tableName, rowCount, attributeName, attributeValue } } })
  });
}


// WEBPACK FOOTER //
// ./src/actions/searchByAttribute.js